module.exports = __webpack_public_path__ + "img/opencart.eaedb8c0.png";